import {
  Button,
  Stack,
  TextField,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText
} from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';
import { ProductCategoryEnum } from '@modules/product/types';
import TextareaEditor from 'common/Editor';

import { TitlesWrapper, VisibleWrapper, StyledFormHelperText } from './styled';
import { useProductLogic } from './useProductLogic';
import ImagesContainer from './components/Images';
import CategorySelect from './components/CategorySelect';

const CreateProduct = () => {
  const {
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    largeImageMessage,
    watch,
    setValue,
    setError,
    setFlowProcess,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
    handleDeleteImage,
  } = useProductLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Product' : 'Create New Product'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('titleAm')}
            label="Title Am"
            error={!!errors.titleAm}
            helperText={errors.titleAm ? 'Title is required' : ''}
          />
          <TextField
            {...register('titleEn')}
            label="Title En"
            error={!!errors.titleEn}
            helperText={errors.titleEn ? 'Title is required' : ''}
          />

          <TextField
            {...register('titleRu')}
            label="Title Ru"
            error={!!errors.titleRu}
            helperText={errors.titleRu ? 'Title is required' : ''}
          />

          <TextareaEditor
            value={watch(`descriptionAm`)}
            label="Description Am"
            name="descriptionAm"
            setValue={setValue}
            error={errors?.descriptionAm?.message}
          />
          <TextareaEditor
            value={watch(`descriptionEn`)}
            label="Description En"
            name="descriptionEn"
            setValue={setValue}
            error={errors?.descriptionEn?.message}
          />
          <TextareaEditor
            value={watch(`descriptionRu`)}
            label="Description Ru"
            name="descriptionRu"
            setValue={setValue}
            error={errors?.descriptionRu?.message}
          />

          <TextareaEditor
            value={watch(`ingredientsAm`)}
            label="Ingredients Am"
            name="ingredientsAm"
            setValue={setValue}
            error={errors?.ingredientsAm?.message}
          />
          <TextareaEditor
            value={watch(`ingredientsEn`)}
            label="Ingredients En"
            name="ingredientsEn"
            setValue={setValue}
            error={errors?.ingredientsEn?.message}
          />
          <TextareaEditor
            value={watch(`ingredientsRu`)}
            label="Ingredients Ru"
            name="ingredientsRu"
            setValue={setValue}
            error={errors?.ingredientsRu?.message}
          />

          <TextareaEditor
            value={watch(`allergensAm`)}
            label="Allergens Am"
            name="allergensAm"
            setValue={setValue}
            error={errors?.allergensAm?.message}
          />
          <TextareaEditor
            value={watch(`allergensEn`)}
            label="Allergens En"
            name="allergensEn"
            setValue={setValue}
            error={errors?.allergensEn?.message}
          />
          <TextareaEditor
            value={watch(`allergensRu`)}
            label="Allergens Ru"
            name="allergensRu"
            setValue={setValue}
            error={errors?.allergensRu?.message}
          />
        </TitlesWrapper>

        <ImagesContainer
          posibilityToMainImage={false}
          keyUploadedFileList="uploadedIconList"
          keyMainImageUrl="mainImageUrl"
          keyExistingImages="existingIcons"
          buttonText="Upload Icon"
          buttontype="outlined"
          setValue={setValue}
          multiple={false}
          handleDeleteImage={handleDeleteImage}
          isImageViewOpen={isImageViewOpen}
          imageSrcForAction={imageSrcForAction}
          setFlowProcess={setFlowProcess}
          onChangeUpload={onChangeUpload}
          helperText="Recommended: 128×128 px or 256×256 px (1:1 square ratio). Transparent PNG or WebP."
        />

        <ImagesContainer
          posibilityToMainImage
          keyUploadedFileList="uploadedFileList"
          keyMainImageUrl="mainImageUrl"
          keyExistingImages="existingImages"
          buttonText="Upload Images"
          setValue={setValue}
          multiple
          handleDeleteImage={handleDeleteImage}
          isImageViewOpen={isImageViewOpen}
          imageSrcForAction={imageSrcForAction}
          setFlowProcess={setFlowProcess}
          onChangeUpload={onChangeUpload}
          helperText="Recommended: 800×1000 px or 620×788 px (~3:4 portrait ratio, centered). Formats: WebP, JPG, PNG."
        />

        <VisibleWrapper>
          <Box>
            <Typography>
              Visibility in website
            </Typography>
            <Box>
              <Radio label="Yes" name="visible" canBe />
              <Radio label="No" name="visible" canBe={false} />
            </Box>
          </Box>
          <CategorySelect watch={watch} setValue={setValue} errors={errors} />
        </VisibleWrapper>

        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default CreateProduct;
